import { ApprovalConfigPermission } from "../../../../../@client/Absents_ConfigApi"
import { AbsenceContext } from "./AbsenceContext"
import { AbsenceConfigValidationError } from "../../../../../@client/Theasoft_Absences_Config"

export function AbsenceConfigContextProvider({
  children,
  ...props
}: {
  children: React.ReactNode
  showIds: boolean
  canModify: ApprovalConfigPermission
  isReadonly: boolean
  validationErrors: AbsenceConfigValidationError[] | null
}) {
  return (
    <AbsenceContext.Provider value={props}>{children}</AbsenceContext.Provider>
  )
}
